module.exports = __webpack_public_path__ + "img/46_23.f7631104.png";